// extracted by mini-css-extract-plugin
module.exports = {"pinterest":"Pinterest_pinterest__uQdhA"};